import { Component } from '@angular/core';

@Component({
  selector: 'app-map-section',
  imports: [],
  templateUrl: './map-section.component.html',
  styleUrl: './map-section.component.css',
})
export class MapSectionComponent {

}
